import React from 'react';
import '../../styles/verification/main.css';

const Main = () => {
    return (
        <div id='VerificationMain'>
            <div className="verification-main">
                <div className="container main-box pb-5">
                    <div className="box">
                        <h1 className="my-heading mt-3">Verification</h1>
                        <div className="details" id="founder">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <p><b>Verification of marks sheets / degree </b></p>
                                <p className='text-justify pt-3'> For verification of marks sheets/ degree, hard copies of attested documents are required to be
                                    sent to <b>Registrar, CCS University, Meerut-250004, Uttar Pradesh</b>. A verification of Rs 350/- must
                                    be paid as bank transfer/demand draft in favour of Finance Officer, Ch Charan Singh University
                                    payable at Meerut.</p>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 mt-4">
                                <p><b>For WES (World Education Services)</b></p>
                                <p className='text-justify pt-3'>  WES has an established relationship with Chaudhary Charan Singh University, Meerut. Electronic
                                    transmission is the preferred method of receiving documents from Chaudhary Charan Singh
                                    University.
                                    <br />
                                    <b>Students are advised to send transcript, degree and academic records request form by
                                        the email to:
                                        <a href="mailto:vigilance@ccsuniversity.ac.in">vigilance@ccsuniversity.ac.in</a></b>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;